import React, { useEffect, useState } from 'react';
import styles from './MileageAnalysisTab_bus.module.css';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import { useVehicleData } from './context';



const RunningHistoryCard = ({ selectedVehicleData, globalFilter, customFilter, benchmarkType }) => {

  const { firstVinNo, secondVinNo } = selectedVehicleData
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const { GlobalData, setGlobalData } = useVehicleData();

  const [storedData, setStoredData] = useState({
    customData: {},
    nationalData: {},
    fleetData: {},
  })

  const [vehicleData, setVehicleData] = useState({
    distance: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null, nationalVehicle: null, fleetVehicle: null, },
    energyConsumed: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null, nationalVehicle: null, fleetVehicle: null, },
    vehicleOperatingHours: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null, nationalVehicle: null, fleetVehicle: null, },
    vehicleUtilization: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null, nationalVehicle: null, fleetVehicle: null, },
  })

  useEffect(() => {
    if (benchmarkType == 'Custom') {
      setStoredData(prev => ({ ...prev, customData: vehicleData }))
    }
    if (benchmarkType == 'National') {
      setStoredData(prev => ({ ...prev, nationalData: vehicleData }))
    }
    if (benchmarkType == 'Fleet') {
      setStoredData(prev => ({ ...prev, fleetData: vehicleData }))
    }

  }, [vehicleData])



  useEffect(() => {
    setGlobalData(prev => ({ ...prev, runningHistory: vehicleData }))
  }, [vehicleData])

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis_ace/mileage_analysis_running_history`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [firstVinNo.vehicleId],
          }
        }
      },
      (res) => {
        const data = res[0]

        setVehicleData(prevState => ({
          ...prevState, // Keep existing bestVehicle and secondaryVehicle data
          distance: { ...prevState.distance, primaryVehicle: data?.Distance?.value?.toFixed(2) ?? null }, // Use .toFixed(2) for numbers
          energyConsumed: { ...prevState.energyConsumed, primaryVehicle: Math.round(data?.Energy_Consumed?.value) ?? null },
          vehicleOperatingHours: { ...prevState.vehicleOperatingHours, primaryVehicle: data?.vehicle_operating_hours?.value ?? null },
          vehicleUtilization: { ...prevState.vehicleUtilization, primaryVehicle: data?.vehicle_utilization?.value?.toFixed(2) ?? null }, // Assuming 0 for no harsh accelerations
        }));

      }
    );
  }, [firstVinNo.vehicleId, globalFilter])

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis_ace/mileage_analysis_best_driven_running_history`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [firstVinNo.vehicleId],
          }
        }
      },
      (res) => {
        const data = res[0]

        setVehicleData(prevState => ({
          ...prevState, // Keep existing bestVehicle and secondaryVehicle data
          distance: { ...prevState.distance, bestVehicle: data?.Distance?.value?.toFixed(2) ?? null }, // Use .toFixed(2) for numbers
          energyConsumed: { ...prevState.energyConsumed, bestVehicle: Math.round(data?.Energy_Consumed?.value) ?? null },
          vehicleOperatingHours: { ...prevState.vehicleOperatingHours, bestVehicle: data?.vehicle_operating_hours?.value ?? null },
          vehicleUtilization: { ...prevState.vehicleUtilization, bestVehicle: data?.vehicle_utilization?.percentage ?? null }, // Assuming 0 for no harsh accelerations
        }));

      }
    );
  }, [firstVinNo.vehicleId, globalFilter])

  // secondary

  useEffect(() => {

    let ApiEndCustom = "mileage_analysis_running_history"
    let APiEndFleet = "mileage_analysis_fleet_running_history"
    let APiEndNational = "mileage_analysis_national_running_history"


    // for custom
    if (secondVinNo?.vehicleId) {
      fetchData(
        {
          url: API_URL_MAIN + `mileage_analysis_ace/${ApiEndCustom}`,
          body: {
            filterdata: {
              ...customFilter,
              "VIN_NUM": [secondVinNo?.vehicleId],
            }
          }
        },
        (res) => {
          const data = res[0]

          setVehicleData(prevState => ({
            ...prevState,
            distance: { ...prevState.distance, secondaryVehicle: data?.Distance?.value?.toFixed(2) ?? null },
            energyConsumed: { ...prevState.energyConsumed, secondaryVehicle: Math.round(data?.Energy_Consumed?.value) ?? null },
            vehicleOperatingHours: { ...prevState.vehicleOperatingHours, secondaryVehicle: data?.vehicle_operating_hours?.value ?? null },
            vehicleUtilization: { ...prevState.vehicleUtilization, secondaryVehicle: data?.vehicle_utilization?.value?.toFixed(2) ?? null },
          }));

        }
      )
    }

    // Fleet

    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis_ace/${APiEndFleet}`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [],
          }
        }
      },
      (res) => {
        const data = res[0]

        setVehicleData(prevState => ({
          ...prevState,
          distance: { ...prevState.distance, fleetVehicle: data?.Distance?.value?.toFixed(2) ?? null },
          energyConsumed: { ...prevState.energyConsumed, fleetVehicle: Math.round(data?.Energy_Consumed?.value) ?? null },
          vehicleOperatingHours: { ...prevState.vehicleOperatingHours, fleetVehicle: data?.vehicle_operating_hours?.value ?? null },
          vehicleUtilization: { ...prevState.vehicleUtilization, fleetVehicle: data?.vehicle_utilization?.value?.toFixed(2) ?? null },
        }));

      }
    )

    //National
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis_ace/${APiEndNational}`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [],
          }
        }
      },
      (res) => {
        const data = res[0]

        setVehicleData(prevState => ({
          ...prevState,
          distance: { ...prevState.distance, nationalVehicle: data?.Distance?.value?.toFixed(2) ?? null },
          energyConsumed: { ...prevState.energyConsumed, nationalVehicle: Math.round(data?.Energy_Consumed?.value) ?? null },
          vehicleOperatingHours: { ...prevState.vehicleOperatingHours, nationalVehicle: data?.vehicle_operating_hours?.value ?? null },
          vehicleUtilization: { ...prevState.vehicleUtilization, nationalVehicle: data?.vehicle_utilization?.value?.toFixed(2) ?? null },
        }));

      }
    )
  }, [secondVinNo?.vehicleId, customFilter, globalFilter, benchmarkType])

  const currentHistoryTabs = [
    {
      key: 'distance',
      name: 'Distance',
      unit: 'Km'
    },
    {
      key: 'energyConsumed',
      name: 'Energy Consumed',
      unit: 'Wh'
    },
    {
      key: 'vehicleOperatingHours',
      name: 'Vehicle Operating Hours',
      unit: ''
    },
    {
      key: 'vehicleUtilization',
      name: 'Vehicle Utilization',
      unit: '%'
    }
  ]




  return (
    <div className="mb-4">
      <div className="d-flex align-items-center mb-3">
        <h6 className={`mb-0 fw-bold ${styles.headerText}`}>
          Running History :
        </h6>
      </div>

      <div className={styles.containerBackground}>
        {/* Distance Row */}

        {
          currentHistoryTabs.map((item, index) =>
            <div className="row mb-2" key={index}>
              <div className="col-3">
                <div className={`p-2 d-flex align-items-center ${styles.labelContainer}`}>
                  <span className={styles.labelText}>{item.name}</span>
                </div>
              </div>
              <div className="col-3">
                <div className={`p-2 d-flex justify-content-center align-items-center ${styles.valueContainer}`}>
                  <span className={styles.valueText}>
                    {
                      item.key === "energyConsumed" ?
                        vehicleData?.[item.key]?.primaryVehicle ? <> {vehicleData?.[item.key]?.primaryVehicle}{" " + item.unit}</> : <>--</>
                        : vehicleData?.[item.key]?.primaryVehicle !== null ? <> {vehicleData?.[item.key]?.primaryVehicle}{" " + item.unit}</> : <>--</>
                    }
                  </span>
                </div>
              </div>
              <div className="col-3">
                <div className={`p-2 d-flex justify-content-center align-items-center ${styles.valueContainer}`}>
                  <span className={styles.valueText}>
                    {
                      item.key === "energyConsumed" ?
                        vehicleData?.[item.key]?.bestVehicle ? <> {vehicleData?.[item.key]?.bestVehicle}{" " + item.unit}</> : <>--</>
                        : vehicleData?.[item.key]?.bestVehicle !== null ? <> {vehicleData?.[item.key]?.bestVehicle}{" " + item.unit}</> : <>--</>
                    }
                  </span>
                </div>
              </div>
              <div className="col-3">
                <div className={`p-2 d-flex justify-content-center align-items-center ${styles.valueContainer}`}>
                  {
                    benchmarkType == "Custom" ?
                      <span className={styles.valueText}>
                        {
                          item.key === "energyConsumed" ?
                            vehicleData?.[item.key]?.secondaryVehicle ? <> {vehicleData?.[item.key]?.secondaryVehicle}{" " + item.unit}</> : <>{secondVinNo?.vehicleId ? <>--</> : ""}</>
                            : vehicleData?.[item.key]?.secondaryVehicle !== null ? <> {vehicleData?.[item.key]?.secondaryVehicle}{" " + item.unit}</> : <>{secondVinNo?.vehicleId ? <>--</> : ""}</>
                        }
                      </span> :
                      benchmarkType == "National" ?
                        <span className={styles.valueText}>
                          {
                            item.key === "energyConsumed" ?
                              vehicleData?.[item.key]?.nationalVehicle ? <> {vehicleData?.[item.key]?.nationalVehicle}{" " + item.unit}</> : <>--</>
                              : vehicleData?.[item.key]?.nationalVehicle !== null ? <> {vehicleData?.[item.key]?.nationalVehicle}{" " + item.unit}</> : <>--</>
                          }
                        </span> :
                        <span className={styles.valueText}>
                          {
                            item.key === "energyConsumed" ?
                              vehicleData?.[item.key]?.fleetVehicle ? <> {vehicleData?.[item.key]?.fleetVehicle}{" " + item.unit}</> : <>--</>
                              : vehicleData?.[item.key]?.fleetVehicle !== null ? <> {vehicleData?.[item.key]?.fleetVehicle}{" " + item.unit}</> : <>--</>
                          }
                        </span>
                  }
                </div>
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default RunningHistoryCard;